import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Select } from '@ngxs/store';
import { BioSealState } from '../../../shared/store/state/bioseal.state';
import { Observable } from 'rxjs';
import { BioSealStateModel } from '../../../shared/model/bioseal.model';
import { UserSandbox } from '../../../shared/sandbox/providers/user.sandbox';
import { DateFormatUtils } from '../../../shared/utils/date-format.utils';
import { CustomValidators } from '../custom-validators';
import { Loinc } from './loinc';
import { take } from 'rxjs/operators';
import { GlobalSandbox } from '../../../shared/sandbox/providers/global.sandbox';

@Component({
  selector: 'id3-covid-test-user-form',
  templateUrl: './covid-test-user-form.component.html',
  styleUrls: ['./covid-test-user-form.component.css'],
  providers: [UserSandbox, GlobalSandbox]
})
export class CovidTestUserFormComponent implements OnInit {

  @Select(BioSealState.isTestFormSubmitted) testSubmitted: Observable<BioSealStateModel>;
  @Select(BioSealState.isPersonalFormSubmitted) personalSubmitted: Observable<BioSealStateModel>;
  @Select(BioSealState.isTestDataLoaded) testData: Observable<BioSealStateModel>;
  @Select(BioSealState.isPersonalDataLoaded) personalData: Observable<BioSealStateModel>;
  PersonalForm;
  TestForm;
  selectedLoinc;
  filteredLoinc: string[];
  loincs: string[];

  @Output() nextEvent = new EventEmitter<boolean>();
  @Output() previousEvent = new EventEmitter<boolean>();

  get gender() {
    return this.PersonalForm.get("gender");
  }

  get result() {
    return this.TestForm.get("result");
  }

  constructor(private formBuilder: FormBuilder, public userSandbox: UserSandbox, public globalSandbox: GlobalSandbox) {

    this.PersonalForm = this.formBuilder.group({
      firstName: ["", Validators.required],
      lastName: ["", Validators.required],
      dob: ["", Validators.required],
      gender: [null, Validators.required]
    });
    this.PersonalForm.statusChanges.subscribe(() =>
      this.userSandbox.onPersonalFormValid({
        data: this.PersonalForm.value,
        validation: this.PersonalForm.valid,
      })
    );

    this.TestForm = this.formBuilder.group({
      loinc: [null,
        [
          Validators.required,
          CustomValidators.loincValidator
        ]
      ],
      result: [null, Validators.required],
      dot: [DateFormatUtils.todayToStringDate(), Validators.required]
    });
    this.TestForm.statusChanges.subscribe(() => {
      this.userSandbox.onTestFormValid({
        data: this.TestForm.value,
        validation: this.TestForm.valid,
      })
    }
    );
  }

  ngOnInit(): void {
    this.loincs = Loinc.loincValues;
  }

  changeGender(e) {
    this.gender.setValue(e.target.value, {
      onlySelf: true,
    });
  }

  changeTestResult(e) {
    this.result.setValue(e.target.value, {
      onlySelf: true,
    });
  }

  filterLoinc(event) {
    this.filteredLoinc = this.loincs.filter(l => l.startsWith(event.query))
  }

  onPersonalSubmit() {
    this.personalData.pipe(take(1)).subscribe((loaded) => {
      if (loaded) {
        this.nextEvent.emit();
      }
      this.userSandbox.onPersonalFormSubmitted();
    });
  }

  onTestSubmit() {
    this.testData.pipe(take(1)).subscribe((loaded) => {
      if (loaded) {
        this.nextEvent.emit();

      }
      this.userSandbox.onTestFormSubmitted();
    });
  }

  previous() {
    this.previousEvent.emit();
  }

}
